(function () {
  const SELECTORS = {
    drawerRoot: "cart-element.cart--root[data-view='drawer']",
    upsellRoot: "[data-cart-upsell]",
    addBtn: "[data-upsell-add]",
  };

  const SPINNER_SVG =
    '<svg class="cu-spinner" viewBox="0 0 50 50" aria-hidden="true"><circle class="cu-path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg>';

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function getCartSectionIds() {
    const ids = Array.from(
      document.querySelectorAll("cart-element.cart--root[data-section-id]")
    )
      .map((el) => el.getAttribute("data-section-id"))
      .filter(Boolean);

    return Array.from(new Set(ids.length ? ids : ["cart-drawer"]));
  }

  function injectStylesOnce() {
    if (document.getElementById("cart-upsell-styles")) return;
    const style = document.createElement("style");
    style.id = "cart-upsell-styles";
    style.textContent = `
      .cu-btnwrap{display:inline-flex;align-items:center;gap:.5rem}
      .cu-spinner{width:16px;height:16px;animation:cu-rot 1s linear infinite}
      .cu-path{stroke:currentColor;stroke-linecap:round;stroke-dasharray:90,150;stroke-dashoffset:0;animation:cu-dash 1.2s ease-in-out infinite}
      @keyframes cu-rot{100%{transform:rotate(360deg)}}
      @keyframes cu-dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}100%{stroke-dasharray:90,150;stroke-dashoffset:-125}}
    `;
    document.head.appendChild(style);
  }

  function setBtnLoading(btn, loading) {
    injectStylesOnce();

    if (loading) {
      if (!btn.dataset.cuOriginalHtml) btn.dataset.cuOriginalHtml = btn.innerHTML;
      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");

      const label = btn.textContent ? btn.textContent.trim() : "Adding…";
      btn.innerHTML = `<span class="cu-btnwrap"><span>${escapeHtml(
        label
      )}</span>${SPINNER_SVG}</span>`;
    } else {
      btn.disabled = false;
      btn.setAttribute("aria-busy", "false");
      if (btn.dataset.cuOriginalHtml) {
        btn.innerHTML = btn.dataset.cuOriginalHtml;
        delete btn.dataset.cuOriginalHtml;
      }
    }
  }

  async function fetchSectionsJSON(sectionIds) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const url = `${root}?sections=${encodeURIComponent(sectionIds.join(","))}`;
    const res = await fetch(url, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error(`sections json failed (${res.status})`);
    return res.json();
  }

  async function fetchSectionHTML(sectionId) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const url = `${root}?section_id=${encodeURIComponent(sectionId)}`;
    const res = await fetch(url, { headers: { Accept: "text/html" } });
    if (!res.ok) throw new Error(`section html failed (${res.status})`);
    return res.text();
  }

  function replaceSectionHTML(sectionId, htmlString) {
    const tmp = document.createElement("div");
    tmp.innerHTML = htmlString;

    const currentSection = document.getElementById(`shopify-section-${sectionId}`);
    const newSection = tmp.querySelector(`#shopify-section-${sectionId}`);
    if (currentSection && newSection) {
      currentSection.innerHTML = newSection.innerHTML;
      return true;
    }

    const newDrawer = tmp.querySelector(SELECTORS.drawerRoot);
    const currentDrawer = document.querySelector(SELECTORS.drawerRoot);
    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
      return true;
    }

    console.warn("[cart-upsell] could not replace section:", sectionId);
    return false;
  }

  function forceFinishTransitions(scope = document) {
    const items = scope.querySelectorAll(
      "[data-transition-item]:not(.cart-upsell--transition)"
    );

    items.forEach((el) => {
      el.setAttribute("data-transition-active", "true");
      el.setAttribute("data-transition-finished", "true");

      if (el.style && el.style.transitionDelay) {
        el.style.transitionDelay = "0ms";
      }
    });
  }

  const upsellControllers = new WeakMap();

  function initUpsell(root) {
    const track = root.querySelector("[data-upsell-track]");
    const prev = root.querySelector("[data-upsell-prev]");
    const next = root.querySelector("[data-upsell-next]");
    if (!track) return;

    const prevCtl = upsellControllers.get(root);
    if (prevCtl) prevCtl.abort();

    const ctl = new AbortController();
    upsellControllers.set(root, ctl);
    const opts = { signal: ctl.signal };

    function maxScroll() {
      const m = track.scrollWidth - track.clientWidth;
      return m > 0 ? m : 0;
    }

    function updateNav() {
      const m = maxScroll();
      const x = track.scrollLeft;
      root.dataset.noScroll = m <= 2 ? "true" : "false";
      if (prev) prev.style.opacity = x <= 2 ? "0.15" : "1";
      if (next) next.style.opacity = x >= m - 2 ? "0.15" : "1";
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(updateNav);
    });
    window.addEventListener("load", updateNav, { once: true });

    if ("ResizeObserver" in window) {
      const ro = new ResizeObserver(() => updateNav());
      ro.observe(track);
      ctl.signal.addEventListener("abort", () => ro.disconnect(), { once: true });
    }

    function scrollClamped(delta) {
      const m = maxScroll();
      const target = Math.max(0, Math.min(track.scrollLeft + delta, m));
      track.scrollTo({ left: target, behavior: "smooth" });
    }

    function getStep() {
      return track.clientWidth;
    }

    if (prev) {
      prev.addEventListener(
        "click",
        () => {
          scrollClamped(-getStep());
        },
        opts
      );
    }

    if (next) {
      next.addEventListener(
        "click",
        () => {
          scrollClamped(getStep());
        },
        opts
      );
    }

    track.addEventListener(
      "scroll",
      () => {
        updateNav();
      },
      { passive: true, signal: ctl.signal }
    );

    setTimeout(updateNav, 50);
  }

  function boot() {
    document.querySelectorAll(SELECTORS.upsellRoot).forEach(initUpsell);
  }

  let refreshInFlight = null;
  let refreshQueued = false;

  function reinitShippingBar() {
    const bar = document.querySelector(".cart--shipping-bar");
    if (!bar) return;

    bar.removeAttribute("data-transition-active");
    bar.removeAttribute("data-transition-finished");
    bar.getBoundingClientRect();
    bar.setAttribute("data-transition-active", "true");
    setTimeout(() => {
      bar.setAttribute("data-transition-finished", "true");
    }, 350);
  }

  async function doRefresh() {
    const sectionIds = getCartSectionIds();

    try {
      const sections = await fetchSectionsJSON(sectionIds);
      sectionIds.forEach((id) => {
        if (sections[id]) replaceSectionHTML(id, sections[id]);
      });
    } catch (e) {
      for (const id of sectionIds) {
        try {
          const html = await fetchSectionHTML(id);
          replaceSectionHTML(id, html);
        } catch (err) {
          console.warn("[cart-upsell] section refresh failed for:", id, err);
        }
      }
    }

    boot();

    document
      .querySelectorAll("cart-element.cart--root")
      .forEach((root) => forceFinishTransitions(root));

    reinitShippingBar();

    document.dispatchEvent(new CustomEvent("cart:updated"));
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }

  function safeRefresh() {
    if (refreshInFlight) {
      refreshQueued = true;
      return refreshInFlight;
    }

    refreshInFlight = (async () => {
      try {
        await doRefresh();
      } finally {
        refreshInFlight = null;
        if (refreshQueued) {
          refreshQueued = false;
          safeRefresh();
        }
      }
    })();

    return refreshInFlight;
  }

  async function addUpsell(variantId, btn) {
    setBtnLoading(btn, true);

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });

      if (!res.ok) {
        const txt = await res.text().catch(() => "");
        console.error("[cart-upsell] add failed:", res.status, txt);
        throw new Error("Add failed");
      }

      await safeRefresh();
    } catch (err) {
      console.error("[cart-upsell] add error", err);
    } finally {
      setBtnLoading(btn, false);
    }
  }

  function onClick(e) {
    const btn = e.target.closest(SELECTORS.addBtn);
    if (!btn) return;

    const variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    e.preventDefault();
    addUpsell(variantId, btn);
  }

  function patchFetchForCartUpdates() {
    if (window.__cuFetchPatched) return;
    window.__cuFetchPatched = true;

    const origFetch = window.fetch.bind(window);

    window.fetch = async (...args) => {
      const url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
      const res = await origFetch(...args);

      try {
        const isCartEndpoint =
          url.indexOf("/cart/add") !== -1 ||
          url.indexOf("/cart/change") !== -1 ||
          url.indexOf("/cart/update") !== -1 ||
          url.indexOf("/cart/clear") !== -1;

        if (isCartEndpoint && res && res.ok) {
          (window.queueMicrotask || ((fn) => Promise.resolve().then(fn)))(() => safeRefresh());
        }
      } catch (_) {}

      return res;
    };
  }

  document.addEventListener("click", onClick);

  document.addEventListener("DOMContentLoaded", () => {
    patchFetchForCartUpdates();
    boot();

    document
      .querySelectorAll("cart-element.cart--root")
      .forEach((root) => forceFinishTransitions(root));
  });

  document.addEventListener("cart:updated", boot);
  document.addEventListener("cart:refresh", boot);
})();